import Alpine from 'alpinejs';

Alpine.data('mapOfficesList', (countryId, cityId) => ({
    countrySelected: countryId,
    citySelected: cityId ?? null,
    forCountry: null, // only used on the map, keep it empty for the tabs renderer
    init() {
        window.addEventListener('selectCity', ($event) => {
            const { country, city } = $event.detail;
            if (country === this.countrySelected) {
                this.selectCityById(country, city);
                setTimeout(() => {
                    this.scrollToTabsContent();
                }, 100);
            }
        });
    },
    selectCityById(countryId, cityId) {
        this.citySelected = cityId;
    },
    scrollToTabsContent() {
        const el = this.$root.querySelector('.map__tabs-content-scroll-position');
        const header = document.querySelector('.header');
        let headerHeight = 0;
        if (header && window.matchMedia('(min-width: 64rem)').matches) {
            headerHeight = header.getBoundingClientRect().top + header.getBoundingClientRect().height;
        }
        const y = el.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scroll({
            top: y,
            behavior: 'smooth',
        });
    },
}));
